import fetcher from 'helpers/fetcher';

export default {
	get () {
		return fetcher.get('user/change/request');
	},	
};
